import { Typography } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { SizingContainer } from 'components/SizingContainer'
import { useTemplate } from 'utils/hook'

import { Text as TextProps } from './interface'

export default function Text({
  text,
  size,
  align,
  variant,
}: TextProps & DefaultElementProps): JSX.Element {
  const render = useTemplate()

  return (
    <SizingContainer className="text-wrap" size={size}>
      <Typography variant={variant} align={align}>
        {render(text)}
      </Typography>
    </SizingContainer>
  )
}
